import { api } from './api';

export interface Variance {
  id: string;
  workspaceId: string;
  accountCode: string;
  periodStart: string;
  budgetAmount: number;
  actualAmount: number;
  varianceAmount: number;
  variancePct: number | null;
  thresholdPct: number | null;
  aiExplanation: string | null;
  // aiExplanationModel intentionally not exposed — CadencEZ AI brand
  // (the column stays populated in the DB for operator observability).
  aiExplanationCitedFacts: number[];
  aiExplanationAt: string | null;
  humanExplanation: string | null;
  approvedBy: string | null;
  approvedAt: string | null;
  createdAt: string;
}

export const variancesApi = {
  async list(workspaceId: string): Promise<Variance[]> {
    const r = await api.get<Variance[]>(`/api/workspaces/${workspaceId}/variances`);
    return r.data;
  },
  async recompute(workspaceId: string, thresholdPct = 5): Promise<{ inserted: number }> {
    const r = await api.post<{ inserted: number }>(
      `/api/workspaces/${workspaceId}/variances/recompute`,
      null,
      { params: { thresholdPct } },
    );
    return r.data;
  },
  async explain(varianceId: string): Promise<Variance> {
    const r = await api.post<Variance>(`/api/variances/${varianceId}/explain`);
    return r.data;
  },
  async update(
    varianceId: string,
    patch: { humanExplanation?: string | null; approved?: boolean },
  ): Promise<Variance> {
    const r = await api.patch<Variance>(`/api/variances/${varianceId}`, patch);
    return r.data;
  },
  /** Audit-grade .xlsx (variances + a resolved cited-facts sheet). */
  async exportXlsx(workspaceId: string): Promise<Blob> {
    const r = await api.get(`/api/workspaces/${workspaceId}/variances/export.xlsx`, { responseType: 'blob' });
    return r.data as Blob;
  },
};
